import { Tag, Tooltip, theme } from 'antd';
import type { AppFeedbackSystemReleaseReason } from 'breuer-supercharged-sdk';
import { systemReleaseLabel } from './feedback_review_utils';

/** Tag „System“ für automatisch weitergegebene Meldungen; nichts bei normaler Entscheidung. */
export function SystemReleaseTag({ reason }: { reason: AppFeedbackSystemReleaseReason | null | undefined }) {
    const { token } = theme.useToken();
    const label = systemReleaseLabel(reason);
    if (!label) return null;
    return (
        <Tooltip title={label.tooltip}>
            <Tag
                style={{
                    marginInlineEnd: 0,
                    color: token.colorText,
                    background: token.colorFillSecondary,
                    borderColor: token.colorBorder,
                }}
            >
                {label.tag}
            </Tag>
        </Tooltip>
    );
}
